import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '~/services/api';
import { CatchErrors } from '../common';

import { tagIndexRequest, tagIndexSuccess, tagIndexFailure, tagCreateSuccess, tagCreateFailure } from './actions';

export function* onIndex() {
  try {
    const response = yield call(api.get, 'tags');

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;

    yield put(tagIndexSuccess(result.data || []));
  }
  catch (err) {
    CatchErrors(err);
    yield put(tagIndexFailure());
  }
}

export function* onCreate({ payload }) {
  try {
    const { data, onCreated } = payload;

    const response = yield call(api.post, 'tags', data);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    yield put(tagCreateSuccess());
    yield put(tagIndexRequest());

    toast.success(result.message);

    if (onCreated) onCreated(result.data);
  }
  catch (err) {
    CatchErrors(err);
    yield put(tagCreateFailure());
  }
}

export default all([
  takeLatest('@tags/INDEX_REQUEST', onIndex),
  takeLatest('@tags/CREATE_REQUEST', onCreate),
]);
